import React, { Component } from 'react';
import loadingGIF from "../../../public/assets/images/loading.gif";


const asyncComponent = (importComponent) => {
    return class extends Component {
        state = {
            component: null
        };

        componentDidMount () {
            try {
                importComponent()
                    .then(cmp => {
                        this.setState({component: cmp.default});
                    })
                    .catch(error => {
                        window.location.reload(true);
                    });
            } catch (error) {
                window.location.reload(true);
            }
        }
        
        render () {
            const UpdatedComponent = this.state.component;
            return UpdatedComponent ? 
                <UpdatedComponent {...this.props} />
                : <img src={loadingGIF} alt="loading..." className="main-loading-gif" />
        }
    }
}

export default asyncComponent;


// WEBPACK FOOTER //
// ./src/components/hoc/asyncComponent/asyncComponent.js